export const parseStringToNumber = (str: string | undefined): number => {
  return Number(str?.replace(/\s/g, ''));
};
